/**
 * NotFound Page
 * Handles 404 errors and redirects to home page
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from '@/shared/components/ui';
import { ROUTES } from '@/shared/config';
import { useSafeThemeClasses } from '@/shared/theme';
import { data } from '@/content/data';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const theme = useSafeThemeClasses();
  const copy = data.notFound;

  useEffect(() => {
    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate(ROUTES.HOME, { replace: true });
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate(ROUTES.HOME, { replace: true });
  };

  return (
    <div className={`min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 ${theme.background}`}>
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h1 className={`text-9xl font-bold ${theme.textMuted}`}>404</h1>
          <h2 className={`mt-4 text-3xl font-bold ${theme.textHeading}`}>{copy.title}</h2>
          <p className={`mt-2 text-lg ${theme.textSecondary}`}>
            {copy.description}
          </p>
        </div>

        <Card className="mt-8 p-8">
          <div className="text-center space-y-6">
            <div className={theme.textMuted}>
              <p>{copy.redirectNotice}</p>
            </div>

            <div className="space-y-4">
              <Button
                onClick={handleGoHome}
                className="w-full"
              >
                {copy.goHome}
              </Button>

              <div className="flex flex-col sm:flex-row gap-2">
                <Button
                  variant="outline"
                  onClick={() => navigate(ROUTES.BLOG)}
                  className="flex-1"
                >
                  {copy.browseBlog}
                </Button>
                <Button
                  variant="outline"
                  onClick={() => navigate(ROUTES.PROJECTS)}
                  className="flex-1"
                >
                  {copy.viewProjects}
                </Button>
              </div>
            </div>

            <div className={`text-sm ${theme.textMuted}`}>
              <p>{copy.supportNote}</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default NotFoundPage;
